import * as hpServicesApi from "../../api/healthPlanServicesApi";
import * as types from "../../constants/actionTypes";
import { call, put, select } from "redux-saga/effects";
import { logAPI } from "../../api/andyliticsApi";

export function* ssoPharmacyBenefits() {
    const sessionData = yield select((state) => state.session);
    const swhp = yield select((state) => state.domain.hi);

    if ((sessionData.healthPlanUserProfile && sessionData.healthPlanUserProfile.roles.includes(hpServicesApi.SsoApi.PortalRoles.optumRXSsoUsers))) {
        yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.optumRX, false);
    } else if (sessionData.healthPlanUserProfile && sessionData.healthPlanUserProfile.roles.includes(hpServicesApi.SsoApi.PortalRoles.navitusSsoUsers)) {
        yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.navitus, false);
    }
    else if (swhp) {
        yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.optumRX, true);
    }
}

export function* ssoFirstCarePlus() {
    const sessionData = yield select((state) => state.session);
    const swhp = yield select((state) => state.domain.hi);
    if (sessionData.healthPlanUserProfile) {
        console.log("healthPlanUserProfile.roles:");
        console.log(sessionData.healthPlanUserProfile.roles);
        if (sessionData.healthPlanUserProfile.roles.includes(hpServicesApi.SsoApi.PortalRoles.alereSsoUsers)) {
            yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.alere, false);
        } else if (sessionData.healthPlanUserProfile.roles.includes(hpServicesApi.SsoApi.PortalRoles.webMDSsoUsers)) {
            yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.webMD, false);
        }
    }
    else if (swhp) {
        yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.webMD, true);
    }
}

export function* ssoNaturallySlim() {
    const sessionData = yield select((state) => state.session);
    const swhp = yield select((state) => state.domain.hi);

    if ((sessionData.healthPlanUserProfile && sessionData.healthPlanUserProfile.roles.includes(hpServicesApi.SsoApi.PortalRoles.naturallySlimSsoUsers))) {
        yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.naturallySlim, false);
    }
    else if (swhp) {
        yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.naturallySlim, true);
    }
}

export function* ssoThrive() {
    const sessionData = yield select((state) => state.session);
    const swhp = yield select((state) => state.domain.hi);
    const healthPlanNetworkCode = yield select((state) => state.domain.nc);

    if (swhp && (healthPlanNetworkCode && healthPlanNetworkCode.includes("BSWE"))) {
        yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.thrive, true);
    }
}

export function* ssoInvoicesandPayments(params) {
    const sessionData = yield select((state) => state.session);
    const swhp = yield select((state) => state.domain.hi);

    if ((sessionData.healthPlanUserProfile && sessionData.healthPlanUserProfile.roles.includes(hpServicesApi.SsoApi.PortalRoles.invoicePaymentSsoUsers))) {
        yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.invoicePayments, false);
    }
    else if (swhp) {
        yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.boa, true, params.contractNumber);
    }
}

export function* ssoTelemedicine() {
    const sessionData = yield select((state) => state.session);
    const swhp = yield select((state) => state.domain.hi);

    if ((sessionData.healthPlanUserProfile && sessionData.healthPlanUserProfile.roles.includes(hpServicesApi.SsoApi.PortalRoles.telemedicineSsoUsers))) {
        yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.telemedicine, false);
    }
    else if (swhp) {
        yield call(ssoToTarget, hpServicesApi.SsoApi.SsoTargets.mdLive, true);
    }
}

function* ssoToTarget(ssoTarget, isAmisys, contractNo) {
    const start = new Date();

    try {
        const response = yield call(hpServicesApi.SsoApi.startSso, ssoTarget, isAmisys, contractNo);
        console.log(response);
        if (ssoTarget.includes(hpServicesApi.SsoApi.SsoTargets.optumRX)) {
            logAPI("MBHWeb.Saga.HealthPlanServices.SSO.Optum", start, null);
        }
        if (ssoTarget.includes(hpServicesApi.SsoApi.SsoTargets.navitus)) {
            logAPI("MBHWeb.Saga.HealthPlanServices.SSO.Navitus", start, null);
        }
        yield put({ type: types.HP_SSO_PHARMACY_SUCCESS, isFetching: false });
    }
    catch (response) {
        console.error(response);
        // Microsoft Edge throws TypeMismatchError when fetch returns 401
        if (response.status === 401 || response.message === 'TypeMismatchError') {
            yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
            logAPI("MBHWeb.Saga.HealthPlanServices.SSO.Optum.Failure", start, null, '401 - login expired or invalid auth token');
        }
        else {
            yield put({ type: types.HP_SSO_PHARMACY_FAILURE, error: response });
            logAPI("MBHWeb.Saga.HealthPlanServices.SSO.Optum.Failure", start, null, response);
        }
    }
}

